import React from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";



const MyPlayers = ({ playerList }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);

  return (
    <div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
      <div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
        <h3 className="xl:text-lg text-base font-extrabold uppercase">{t('my-players')}</h3>
        <Link to={'../manage-player'} className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
      </div>
      <div className="panel-body w-full">
        <div className="overflow-x-auto">
          <table className="table table-row-hover w-full">
            <tbody className="divide-y divide-gray-200">
              {playerList && playerList?.map((player, index) => (
                <tr key={index}>
                  <td>
                    <div className="flex max-sm:flex-wrap items-center gap-3">
                      <div className="size-10 bg-blue-700 rounded-lg overflow-hidden">
                        <img className="size-full object-cover" src={player?.photo} alt={player?.fullName} />
                      </div>
                      <div>
                        <p className="font-bold uppercase">{player?.fullName}</p>
                      </div>
                    </div>
                  </td>
                  <td className="text-end">
                    <span className="pl-2 py-1 pr-2.5 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
                      <img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> {player?.rating}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default MyPlayers